import work1 from "../../assets/images/works/work1.jpg";
import work2 from "../../assets/images/works/work2.jpg";
import work3 from "../../assets/images/works/work3.jpg";
import work4 from "../../assets/images/works/work4.jpg";
import work5 from "../../assets/images/works/work5.jpg";
import work6 from "../../assets/images/works/work6.jpg";

function Works() {
  const works = [
    {
      title: "ECサイトリニューアル",
      category: "Web制作",
      description: "レスポンシブ対応とSEO最適化により売上30%向上を実現",
      image: work1,
    },
    {
      title: "業務管理アプリ開発",
      category: "アプリ開発",
      description: "クロスプラットフォーム対応で業務効率を大幅改善",
      image: work2,
    },
    {
      title: "予約システム構築",
      category: "Web制作",
      description: "直感的なUIで予約率が約1.5倍に増加",
      image: work3,
    },
    {
      title: "コーポレートサイト制作",
      category: "Web制作",
      description: "企業ブランディングを強化する洗練されたデザイン",
      image: work4,
    },
    {
      title: "在庫管理システム",
      category: "アプリ開発",
      description: "入出庫・移動・棚卸を一元管理し、在庫差異の原因追跡が可能に",
      image: work5,
    },
    {
      title: "ポートフォリオサイト",
      category: "Web制作",
      description: "クリエイターの作品を魅力的に展示するギャラリーサイト",
      image: work6,
    },
  ];

  return (
    <section
      id="works"
      className="relative overflow-hidden bg-white px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="fade-in-section mb-12 text-center md:mb-20">
          <h2 className="mb-3 text-4xl font-semibold text-gray-900 md:mb-4 md:text-6xl">
            <span className="text-red-500">W</span>orks
          </h2>
          <p className="text-gray-600">制作実績</p>
        </div>
        <div
          className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3"
          data-product-shop
        >
          {works.map((work, index) => (
            <div
              key={index}
              className="fade-in-section overflow-hidden rounded-xl border-2 border-gray-200 bg-white shadow-md transition-all duration-300"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={work.image}
                  alt={work.title}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="mb-2 text-lg font-semibold text-gray-900">
                  {work.title}
                </h3>
                <div className="mb-3 inline-block rounded-full bg-red-50 px-3 py-1 text-xs text-red-500">
                  {work.category}
                </div>
                <p className="line-clamp-2 text-sm leading-relaxed text-gray-600">
                  {work.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Works;
